import Loader from '@/components/atoms/loader/loader';
import TableDesktop from '@/components/atoms/table-desktop/table';
import NoExpiredSubsidies from '@/components/molecules/no-expired-subsidies/no-expired-subsidies';
import TableMovil from '@/components/molecules/table-movil/table-movil';

type DetalleCuentaReport = {
  periodo: string;
  fechaPago: string;
  valorGirado: string;
  rangoValorGirado: string;
  empleador: string;
  consumido: string;
  pagadoA: string;
  medioPago: string;
  entidadFinanciera: string;
  prescripcion: string;
  tipoSubsidio: string;
};

type ExpiredSubsidiesProps = {
  noData: boolean;
  loading: boolean;
  setNoData: (any) => void;
  mobile: boolean;
  tableDataMonetary: DetalleCuentaReport[];
  lista: string[];
  redirectURL: string;
};

const ExpiredSubsidies = ({
  noData,
  loading,
  redirectURL,
  mobile,
  tableDataMonetary,
  lista,
}: ExpiredSubsidiesProps) => {
  return (
    <>
      {loading && (
        <div className="loaderContainer__big">
          <Loader size="__big" />
        </div>
      )}
      {noData && !loading && <NoExpiredSubsidies redirectURL={redirectURL} />}
      {!mobile && !loading && !noData && <TableDesktop rows={tableDataMonetary} headers={lista} />}
      {mobile && !loading && !noData && <TableMovil tableData={tableDataMonetary} />}
    </>
  );
};

export default ExpiredSubsidies;
